import React from 'react';
import { func, bool, string } from 'prop-types';

// Import components
import AuthMethodButton from './AuthMethodButton';

// Import helpers
import { authProviders, AUTH_METHODS } from '../helpers';

const AuthMethodsButtons = ({
	authenticationSubmit,
	showPhoneAuth,
	setIsPhoneAuthView,
	sourceName
}) => {
	if (!authProviders.length) return null;

	return (
		<>
			{authProviders.map(({ name, authProvider }) => (
				<AuthMethodButton
					key={name}
					onClick={authenticationSubmit}
					method={name}
					authProvider={authProvider}
					sourceName={sourceName}
				/>
			))}
			{showPhoneAuth && (
				<AuthMethodButton
					onClick={setIsPhoneAuthView}
					method={AUTH_METHODS.PHONE}
					authProvider={AUTH_METHODS.PHONE}
				/>
			)}
		</>
	);
};

AuthMethodsButtons.propTypes = {
	authenticationSubmit: func.isRequired,
	showPhoneAuth: bool.isRequired,
	setIsPhoneAuthView: func.isRequired,
	sourceName: string
};

export default AuthMethodsButtons;
